export function EthosLogo({ className = "" }: { className?: string }): React.ReactElement {
  return (
    <span className={`ethos-logo ${className}`.trim()}>
      <img src="/ethos-logo-master.png" alt="ETHOS" />
    </span>
  );
}
